import React, { Fragment, useState } from 'react'
import { useIntl } from 'react-intl'
import { Chapter } from '@/app/models/new-resource'
import ArticleChapter from '../ArticleChapter/ArticleChapter'
import ActionItemContainer from '../../UI/ActionItemContainer/ActionItemContainer'
import ActionItemDone from '../../ActivityCreation/Action/ActionItemDone/ActionItemDone'
import './ArticleChapters.scss'

const ArticleChapters = (props: {
    chaptersList: Chapter[]
    onAddChapter: (chapter: Chapter) => void
    onSaveChapter: (chapterIndex: number, chapter: Chapter) => void
    onEditChapter: (chapterIndex: number, chapter: Chapter) => void
    onRemoveChapter: (questionIndex: number) => void
    onReduceChapter: (chapterIndex: number, chapter: Chapter) => void
}) => {
    const {
        chaptersList,
        onAddChapter,
        onSaveChapter,
        onEditChapter,
        onRemoveChapter,
        onReduceChapter,
    } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-new-resource-article-chapters'

    const [showAddLink, setAddLink] = useState(false)

    const onAddChapterHandler = () => {
        setAddLink(false) // setAddLink false at the start
        onAddChapter({
            text: '',
            title: '',
            attachments: [],
            index: chaptersList?.length + 1,
        })
        // setAddLink(true) // setAddLink true at the end
    }

    const onSaveChapterHandler = (index: number, whichChapter: Chapter) => {
        setAddLink(false) // setAddLink false at the start
        onSaveChapter(index, whichChapter)
    }

    const onEditChapterHandler = (index: number, whichChapter: Chapter) => {
        setAddLink(false) // setAddLink false at the start
        onEditChapter(index, { ...whichChapter, isEdit: true })
        // setAddLink(true) // setAddLink true at the end
    }

    const onReduceChapterHandler = (index: number, whichChapter: Chapter) => {
        setAddLink(false) // setAddLink false at the start
        onReduceChapter(index, whichChapter)
    }

    return (
        <div className={componentClass}>
            <ActionItemContainer
                showAddLink={showAddLink}
                hasItems={chaptersList?.length > 0}
                onAddItem={() => onAddChapterHandler()}
                title={intl.formatMessage({
                    id: 'modals.new.activity.section.action.item.title.chapter',
                    defaultMessage: 'Add chapter',
                })}>
                {chaptersList?.length > 0 &&
                    chaptersList.map((chapter: Chapter, index: number) => (
                        <Fragment key={index}>
                            {chapter.isDone && !chapter.isEdit && (
                                <ActionItemDone
                                    title={intl.formatMessage(
                                        {
                                            id: 'modals.new.activity.section.action.chapter.done',
                                            defaultMessage: 'Saved chapter is here',
                                        },
                                        { index: index + 1 }
                                    )}
                                    onRemove={() => onRemoveChapter(index)}
                                    onEdit={() => onEditChapterHandler(index, chapter)}
                                />
                            )}
                            {(!chapter.isDone || chapter.isEdit) && (
                                <ArticleChapter
                                    index={index}
                                    disabled={false}
                                    chapter={chapter}
                                    onSaveChapter={(whichChapter: Chapter) =>
                                        onSaveChapterHandler(index, whichChapter)
                                    }
                                    onReduceChapter={() => onReduceChapterHandler(index, chapter)}
                                />
                            )}
                        </Fragment>
                    ))}
            </ActionItemContainer>
        </div>
    )
}

export default ArticleChapters
